module.exports = __webpack_public_path__ + "img/3享溫馨.2f78e265.jpg";